// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"98b296e8","426":"f3978c55","477":"57fc2fbf","507":"bf2454e4","824":"d83c5150","829":"7685849e","830":"893a3f4a","981":"dacc3ca0"}[chunkId] + ".chunk.js";
};